import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import vSelect from 'vue-select'

import router from './router'
import store from './store'
import App from './App.vue'
import CommonMixin from "@/@core/mixins/ui/common";
import PermissionsMixin from "@/auth/permission";

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/vue-select'
import '@/libs/sweet-alerts'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueApexCharts)

// Composition API
Vue.use(VueCompositionAPI)

// registering global mixin
Vue.mixin(CommonMixin);
Vue.mixin(PermissionsMixin);

Vue.component('vue-select', vSelect)
Vue.component('apexchart', VueApexCharts)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
